<template>
  <CancerView icd="C34sample" icd-presentation-string="C34"
              icd-description="Malignant neoplasm of bronchus and lung (sample)"
              disease-description="lung cancer"
              :mesh-ids="['D008175']"
              mesh-description="Lung Neoplasms"
              :dashboard6-included="false">
  </CancerView>
</template>

<script>
import CancerView from '@/components/CancerView.vue';
import {defineComponent} from "vue";

export default defineComponent({
  name: 'lung-cancer-sample-page',
  components: {
    CancerView
  }
});
</script>
